/**
 * Extract a language-specific field from an event object.
 *
 * Checks event.data JSON (keys 'english'/'chinese' from server,
 * 'en'/'zh' as legacy aliases) before falling back to the top-level field.
 *
 * @param {object} event   - event object from the API
 * @param {string} field   - field name (e.g. 'title', 'description')
 * @param {string} lang    - 'zh' or 'en'
 * @returns {*} the field value, or null
 */
export function langField(event, field, lang) {
  if (event.data) {
    try {
      const d = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      const keys = lang === 'zh' ? ['chinese', 'zh'] : ['english', 'en'];
      for (const k of keys) {
        const block = d[k];
        if (block && block[field] != null && block[field] !== '') {
          return block[field];
        }
      }
    } catch {
      // fall through
    }
  }
  return event[field] ?? null;
}

/**
 * Extract tags array from event for the given language.
 * Returns an array of strings.
 */
export function langTags(event, lang) {
  if (event.data) {
    try {
      const d = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      const keys = lang === 'zh' ? ['chinese', 'zh'] : ['english', 'en'];
      for (const k of keys) {
        if (d[k] && Array.isArray(d[k].tags) && d[k].tags.length > 0) {
          return d[k].tags;
        }
      }
    } catch {
      // fall through
    }
  }
  if (event.tags) {
    return event.tags.split(',').map(t => t.trim()).filter(Boolean);
  }
  return [];
}
